import { Company } from '../../../models';
import { runReport, RunReportResponse } from '../../../api';
import { RuleBuilderField } from '../rule-builder';
import { createRunReportPayload } from '../../find-report/helpers/createRunReportPayload';
import { ReportSettingState } from '../../find-report/report-setting';
import { format } from 'date-fns';
import { DATE_TIME_FORMAT } from '../../../constants';

const runCustomReport = async (
  client: Company,
  reportSettingState: ReportSettingState,
  ruleBuilderFields: RuleBuilderField[],
  reportName?: string,
): Promise<RunReportResponse> => {
  const timeStamp = format(Date.now(), DATE_TIME_FORMAT.FULL_DATE_TIME);
  const payload = createRunReportPayload(
    client,
    null, // no standard report specified
    reportSettingState,
    ruleBuilderFields,
    reportName || `Custom Report - ${timeStamp}`,
  );
  return runReport(payload);
};

export { runCustomReport };
